import CurrentUserStore from 'CurrentUserStore';
import NetClient from 'NetClient';
import CurrencyController from 'CurrencyController';
import {NativeModules} from 'react-native';
const OnError = NativeModules.SKZAPIManager.OnError;

export type WithdrawalRequest = {
  id: number;
  user_id: number;
  amount: number;
  fee: number;
  bonus: number;
  created_at: string;
  withdrawal_type: 'PAYPAL' | 'CHECK' | 'AEROPAY';
};

export type CancelAllWithdrawalsResponse = {
  successfulWithdrawals: WithdrawalRequest[];
  failedWithdrawals: WithdrawalRequest[];
};
export async function cancelAllWithdrawals(
  withdrawalRequests: WithdrawalRequest[]
): Promise<CancelAllWithdrawalsResponse> {
  const userId = await CurrentUserStore.getCurrentUserId();
  const successfulWithdrawals: WithdrawalRequest[] = [];
  const failedWithdrawals: WithdrawalRequest[] = [];

  // Server can only handle a single cancellation at a time due to db locks
  for (const withdrawalRequest of withdrawalRequests) {
    const url = buildRequestUrl(userId, withdrawalRequest);
    await NetClient.deleteURL(url, {}, OnError.failSilently, () => null)
      .then(() => {
        successfulWithdrawals.push(withdrawalRequest);
      })
      .catch((error: Object) => {
        console.error(`Failed to cancel withdrawal request ${withdrawalRequest.id}:`, error);
        failedWithdrawals.push(withdrawalRequest);
      });
  }

  return {
    successfulWithdrawals,
    failedWithdrawals,
  };
}

function buildRequestUrl(userId: string, withdrawRequest: WithdrawalRequest): string {
  if (!CurrencyController.isUSD()) {
    return `/payment/v2/withdrawal-requests/${withdrawRequest.id}`;
  }

  if (withdrawRequest.withdrawal_type === 'PAYPAL') {
    return `users/${userId}/paypal_withdrawal_requests/${withdrawRequest.id}`;
  }

  return `users/${userId}/withdrawal_requests/${withdrawRequest.id}`;
}
